// extracted by mini-css-extract-plugin
module.exports = {"c39fi53":"c39fi53","i1pbfrif":"i1pbfrif","l1cohl0w":"l1cohl0w"};